import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Select,
  Typography,
  Row,
  Checkbox,
  Tooltip,
} from "antd";
import { useNavigate } from "react-router-dom";
import styles from "./index.module.css";
import { useSelector, useDispatch } from "react-redux";
import {
  getFields,
  saveStep,
  updateStep,
  calculatePremium,
  setDentalCare,
  setOutPatientCare,
  setOpticalCare,
} from "../../../store/policy";
import moment from "moment";
import { validationRules } from "../../common/Utils";
import {
  FileCheck,
  Shield,
  ExternalLink,
  ArrowLeft,
  ArrowRight,
  HelpCircle,
  Loader,
  Check,
} from "lucide-react";
import viewCover from '../../../utils/pdf/viewPolicy.pdf'

const tooltipContent = {
  lifeDisability: `Life & Disability Cover provides financial support for beneficiaries in
the event of the insured's death or permanent disability, Adding this
cover to your medical insurance ensures comprehensive protection for
you and your loved ones, safeguarding against unexpected life events.`,
  personalAccident: `Personal Accident Cover offers compensation for injuries or
death resulting from accidents, ensuring financial protection
against unforeseen incidents.Adding this cover to your medical
insurance ensures comprehensive protection for you and your
loved ones, safeguarding against unexpected life events.`,
};

function Index({ current, setCurrent }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form1] = Form.useForm();
  const [sortedFields, setSortedFields] = useState([]);
  const [lifeDisabilityCover, setLifeDisabilityCover] = useState("");
  const [personalAccidentCover, setPersonalAccidentCover] = useState("");
  const existingValues = sessionStorage.getItem("values");
  const user = sessionStorage.getItem("user");
  const coverageCountry = localStorage.getItem("coverageCountry")
    ? localStorage.getItem("coverageCountry")
    : "";

  const nextStep = () => {
    form1
      .validateFields()
      .then(() => {
        const values = form1.getFieldsValue();
        if (
          !form1.isFieldsTouched() &&
          existingValues &&
          JSON.parse(existingValues).find(
            (step) =>
              step.step_id === steps.find((s) => s?.step_number === current)?.id
          )
        ) {
          setCurrent(4);
        } else if (
          existingValues &&
          JSON.parse(existingValues)?.find(
            (step) =>
              step.step_id ===
              steps?.find((s) => s?.step_number === current)?.id
          )
        ) {
          dispatch(
            updateStep({
              userId: JSON.parse(sessionStorage.getItem("user"))?.userId,
              stepId: steps?.find((s) => s?.step_number === current)?.id,
              parameters: fields?.map((field, i) => {
                return {
                  field_id: field?.id,
                  key: field?.field_name,
                  value: values[field?.field_name],
                };
              }),
            })
          );
          localStorage.removeItem("lastStep");
        } else {
          dispatch(
            saveStep({
              source: steps?.find((s) => s?.step_number === current)
                ?.step_source,
              user_id: JSON.parse(sessionStorage.getItem("user"))?.userId,
              step_id: steps?.find((s) => s?.step_number === current)?.id,
              parameters: fields?.map((field, i) => {
                return {
                  field_id: field?.id,
                  key: field?.field_name,
                  value: values[field?.field_name],
                };
              }),
            })
          );
        }
      })
      .then(() => setCurrent(4))
      .catch((err) => console.log(err));
  };

  const {
    steps,
    fields,
    plan,
    flag,
    outPatientCare,
    dentalCare,
    opticalCare,
    premiumLoading,
  } = useSelector((state) => state.policySlice);

  useEffect(() => {
    if (
      steps &&
      steps?.find((s) => s?.step_number === current) &&
      steps?.find((s) => s?.step_number === current).form_id &&
      steps?.find((s) => s?.step_number === current).id
    ) {
      dispatch(
        getFields({
          formId: steps?.find((s) => s?.step_number === current).form_id,
          stepId: steps?.find((s) => s?.step_number === current).id,
        })
      ).then((res) => {
        const localFields = res?.payload &&
          Array.isArray(res?.payload) && [...res?.payload];
        setSortedFields(
          localFields?.sort((a, b) => a?.field_sequence - b?.field_sequence)
        );
      });
    }
  }, [steps]);

  useEffect(() => {
    if (
      existingValues &&
      JSON.parse(existingValues)?.find(
        (step) =>
          step.step_id === steps?.find((s) => s?.step_number === current)?.id
      )
    ) {
      const values = JSON.parse(existingValues)?.find(
        (step) =>
          step.step_id === steps?.find((s) => s?.step_number === current)?.id
      ).parameters;

      const obj = new Object();
      for (let key of values) {
        obj[key.key] = key.value;
      }
      form1.setFieldsValue(obj);
    }
  }, [steps]);

  useEffect(() => {
    if (flag) {
      const selectedPlan =
        localStorage.getItem("selectedPlan") &&
        JSON.parse(localStorage.getItem("selectedPlan"));

      const coPayment =
        existingValues &&
        JSON.parse(existingValues)
          ?.find((s) => s?.source === "policy_information")
          ?.parameters?.find((co) => co?.key === "outpatient_copay")?.value;

      const findScope =
        sessionStorage.getItem("values") &&
        JSON.parse(sessionStorage.getItem("values")).find(
          (step) => step.source === "cover_scope"
        )?.parameters;

      const medicalQuestions =
        sessionStorage.getItem("values") &&
        JSON.parse(sessionStorage.getItem("values")).find(
          (step) => step.source === "dependents"
        )?.parameters;

      const options = {
        user_id: JSON.parse(user)?.userId,
        cover_start_date: moment().format("YYYY-MM-DD"),
        plan_id: selectedPlan?.coverage_plan?.plan_id,
        plan_options: selectedPlan?.coverage_plan?.plan_name,
        co_payment: coPayment,
        age_of_principal:
          findScope.find((par) => par.key === "dob") &&
          findScope.find((par) => par.key === "dob").value
            ? moment().diff(
                findScope.find((par) => par.key === "dob").value,
                "years"
              )
            : 12,

        number_of_children: findScope.find(
          (par) => par.key === "principal_children_count"
        )
          ? findScope.find((par) => par.key === "principal_children_count")
              .value
          : "2",

        payment_options: "12",

        option2:
          medicalQuestions?.find((par) => par.key === "question1").value === "0"
            ? false
            : true,
        option3:
          medicalQuestions?.find((par) => par.key === "question2").value === "0"
            ? false
            : true,
        option4:
          medicalQuestions?.find((par) => par.key === "question3").value === "0"
            ? false
            : true,
        option5:
          medicalQuestions?.find((par) => par.key === "question4").value === "0"
            ? false
            : true,
      };
      if (
        sessionStorage.getItem("values") &&
        JSON.parse(sessionStorage.getItem("values")).find(
          (step) => step.source === "principal_member"
        )?.parameters &&
        JSON.parse(sessionStorage.getItem("values"))
          .find((step) => step.source === "principal_member")
          ?.parameters?.find((par) => par.key === "insurance_company")?.value
      ) {
        options["option1"] = JSON.parse(sessionStorage.getItem("values"))
          .find((step) => step.source === "principal_member")
          ?.parameters?.find((par) => par.key === "insurance_company")?.value
          ? true
          : false;
      }
      if (
        findScope.find((par) => par.key === "principal_spouse_age") &&
        findScope.find((par) => par.key === "principal_spouse_age").value
      ) {
        options["age_of_spouse"] = moment().diff(
          findScope.find((par) => par.key === "principal_spouse_age").value,
          "years"
        );
      }
      const values =
        existingValues &&
        JSON.parse(existingValues)?.find(
          (s) => s?.source === "policy_information"
        )?.parameters;
      if (
        values &&
        values.find((key) => key.key === "payment_frequency") &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        options["payment_options"] = values.find(
          (key) => key.key === "payment_frequency"
        )?.value;
      }
      if (
        values &&
        values.find((key) => key.key === "cover_period") &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        options["cover_period"] = values.find(
          (key) => key.key === "cover_period"
        )?.value;
      }
      if (
        values &&
        values.find((key) => key.key === "preferred_msp_list") &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        options["preferred_msp_list"] = values.find(
          (key) => key.key === "preferred_msp_list"
        )?.value;
      }
      if (
        values &&
        values.find((key) => key.key === "covertype") &&
        localStorage.getItem("coverageCountry") === "Kenya"
      ) {
        options["type_of_cover"] = values.find(
          (key) => key.key === "covertype"
        )?.value;
      }
      if (localStorage.getItem("coverageCountry") === "Kenya") {
        options["outpatient_care"] = outPatientCare;
        options["dental_care"] = dentalCare;
        options["optical_care"] = opticalCare;
      }
      if (lifeDisabilityCover && parseInt(lifeDisabilityCover)) {
        options["life_and_disability_cover"] = lifeDisabilityCover;
      }
      if (personalAccidentCover && parseInt(personalAccidentCover)) {
        options["personal_accident"] = personalAccidentCover;
      }
      options["plan_id"] = localStorage.getItem("selectedPlanId") ??
      "PLAN051";
      dispatch(calculatePremium(options));
    }
  }, [
    flag,
    outPatientCare,
    dentalCare,
    opticalCare,
    lifeDisabilityCover,
    personalAccidentCover,
  ]);

  return (
    <div className={styles.stepWrapper}>
      <div className={styles.splitLayout}>
        {/* Left: Policy Options */}
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <div className={styles.cardIcon}>
              <FileCheck size={22} />
            </div>
            <div>
              <h3 className={styles.cardTitle}>Policy Information</h3>
              <span className={styles.cardDesc}>
                {sortedFields.length > 0 && sortedFields?.[0]?.heading}
              </span>
            </div>
          </div>
          <div className={styles.cardBody}>
            <Form
              form={form1}
              layout="vertical"
            >
              {sortedFields &&
                sortedFields.length > 0 &&
                sortedFields?.map((field, index) => {
                  return (
                    <Form.Item
                      className={styles.formItem}
                      key={index}
                      label={
                        <div className={styles.fieldLabelWrap}>
                          {field?.main_heading && (
                            <div className={styles.fieldMainHeading}>
                              {field?.main_heading}
                            </div>
                          )}
                          {field?.information && (
                            <div className={styles.fieldInfo}>{field?.information}</div>
                          )}
                          {field?.label &&
                          (field?.label === "Life & Disability Cover" ||
                            field?.label === "Personal Accident Cover") ? (
                            <span className={styles.fieldLabel}>
                              {field?.label}
                              <Tooltip
                                title={
                                  field?.label === "Life & Disability Cover"
                                    ? tooltipContent.lifeDisability
                                    : tooltipContent.personalAccident
                                }
                              >
                                <HelpCircle size={14} color="#64748b" style={{ cursor: "pointer" }} />
                              </Tooltip>
                            </span>
                          ) : (
                            <span className={styles.fieldLabel}>{field?.label}</span>
                          )}
                        </div>
                      }
                      id={field?.id}
                      name={field?.field_name}
                      rules={validationRules(
                        field?.validation,
                        field?.label,
                        field?.type
                      )}
                    >
                      {field?.type === "dropdown" ? (
                        <Select
                          allowClear
                          placeholder={field?.label}
                          options={field?.dropdowns
                            ?.filter((r) =>
                              r?.regions?.find((r) => r === coverageCountry)
                            )?.[0]
                            ?.values?.map((opt) => {
                              return {
                                label:
                                  opt?.name && !isNaN(parseInt(opt?.name))
                                    ? parseInt(opt?.name).toLocaleString("US")
                                    : opt?.name,
                                value: opt?.value,
                              };
                            })}
                          className={styles.fieldSelect}
                          value={field?.value}
                          onChange={(e, v) => {
                            if (field?.label === "Life & Disability Cover" )
                              setLifeDisabilityCover(e);
                            if (field?.label === "Personal Accident Cover" )
                              setPersonalAccidentCover(e);
                          }}
                        />
                      ) : (
                        ""
                      )}
                    </Form.Item>
                  );
                })}
            </Form>
          </div>
        </div>

        {/* Right: Cover Benefits */}
        <CoverBenefits
          totalValue={plan?.premium_amount}
          coverBenefits={plan?.coverage_plan?.options}
          planName={plan?.coverage_plan?.plan_name}
          outPatientCare={outPatientCare}
          dentalCare={dentalCare}
          opticalCare={opticalCare}
          onRadioChange={(service) => {
            if (service === "Outpatient Care") {
              dispatch(setOutPatientCare());
            } else if (service === "Dental Care Coverage") {
              dispatch(setDentalCare());
            } else {
              dispatch(setOpticalCare());
            }
          }}
          premiumLoading={premiumLoading}
          form={form1}
          lifeDisabilityCover={lifeDisabilityCover}
          personalAccidentCover={personalAccidentCover}
        />
      </div>

      <div className={styles.actions}>
        <Button
          className={styles.backBtn}
          onClick={() => setCurrent((prev) => prev - 1)}
        >
          <ArrowLeft size={16} />
          Back
        </Button>
        <Button
          type="primary"
          className={styles.continueBtn}
          onClick={nextStep}
        >
          Continue
          <ArrowRight size={16} />
        </Button>
      </div>
    </div>
  );
}

export default Index;

const CoverBenefits = ({
  totalValue,
  coverBenefits,
  planName,
  onRadioChange,
  outPatientCare,
  dentalCare,
  opticalCare,
  premiumLoading,
  lifeDisabilityCover,
  personalAccidentCover,
  form,
}) => {
  const validBenefits = [
    "Inpatient Care",
    "Outpatient Care",
    "Dental Care Coverage",
    "Optical Care Coverage",
  ];

  const additionalBenefits = [
    {
      name: "Life and Disability cover",
      value: lifeDisabilityCover,
      show: !!lifeDisabilityCover
    },
    {
      name: "Personal Accident Cover",
      value: personalAccidentCover,
      show: !!personalAccidentCover
    }
  ];

  return (
    <div className={styles.benefitsCard}>
      {/* Header */}
      <div className={styles.benefitsHeader}>
        <div className={styles.benefitsIcon}>
          <Shield size={20} />
        </div>
        <div>
          <div className={styles.benefitsLabel}>Policy Premium</div>
          <div className={styles.benefitsPlanName}>{planName}</div>
        </div>
      </div>

      {/* Benefits List */}
      <div className={styles.benefitsBody}>
        <button
          type="button"
          className={styles.viewCoverLink}
          onClick={() => window.open(viewCover, '_blank')}
        >
          <ExternalLink size={14} />
          Full Cover Details
        </button>

        <div className={styles.benefitsList}>
          {coverBenefits
            ?.filter((ben) => {
              if (!isNaN(parseInt(ben.value))) {
                if (
                  localStorage.getItem("coverageCountry") === "Kenya" &&
                  validBenefits.indexOf(ben.name) !== -1
                ) {
                  return true;
                } else if (
                  localStorage.getItem("coverageCountry") !== "Kenya"
                ) {
                  return true;
                }
              }
              return false;
            })
            ?.map((benefit, index) => (
              <div key={index} className={styles.benefitRow}>
                <div className={styles.benefitLeft}>
                  {localStorage.getItem("coverageCountry") === "Kenya" &&
                  (benefit.name === "Outpatient Care" ||
                    benefit.name === "Dental Care Coverage" ||
                    benefit.name === "Optical Care Coverage") ? (
                    <Checkbox
                      onClick={() => onRadioChange(benefit.name)}
                      checked={
                        benefit.name === "Outpatient Care"
                          ? outPatientCare
                          : benefit.name === "Dental Care Coverage"
                          ? dentalCare
                          : opticalCare
                      }
                    />
                  ) : (
                    <div className={styles.benefitCheck}>
                      <Check size={14} />
                    </div>
                  )}
                  <span className={styles.benefitName}>{benefit.name}</span>
                </div>
                <span className={styles.benefitValue}>
                  {`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(benefit.value?.replace(/,/g, "")).toLocaleString("US")}`}
                </span>
              </div>
            ))}

          {additionalBenefits.map((benefit, index) => {
            if (benefit.show) {
              return (
                <div key={`additional-${index}`} className={styles.benefitRow}>
                  <div className={styles.benefitLeft}>
                    <div className={styles.benefitCheck}>
                      <Check size={14} />
                    </div>
                    <span className={styles.benefitName}>{benefit.name}</span>
                  </div>
                  <span className={styles.benefitValue}>
                    {`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(benefit.value).toLocaleString("US")}`}
                  </span>
                </div>
              );
            }
            return null;
          })}
        </div>
      </div>

      {/* Premium Breakdown */}
      {!premiumLoading && totalValue && (
        <div className={styles.premiumBreakdown}>
          <div className={styles.breakdownTitle}>Premium Calculation Breakdown</div>
          <div className={styles.breakdownItems}>
            <div className={styles.breakdownItem}>
              <span>Base Premium</span>
              <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.base_premium).toLocaleString("US")}`}</span>
            </div>
            {totalValue.life_and_disability_cover_premium > 0 && (
              <div className={styles.breakdownItem}>
                <span>Life & Disability Cover</span>
                <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.life_and_disability_cover_premium).toLocaleString("US")}`}</span>
              </div>
            )}
            {totalValue.personal_accident_premium > 0 && (
              <div className={styles.breakdownItem}>
                <span>Personal Accident Cover</span>
                <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.personal_accident_premium).toLocaleString("US")}`}</span>
              </div>
            )}
            <div className={styles.breakdownItem}>
              <span>Training Levy</span>
              <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.training_levy).toLocaleString("US")}`}</span>
            </div>
            <div className={styles.breakdownItem}>
              <span>PCF Levy</span>
              <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.pcf_levy).toLocaleString("US")}`}</span>
            </div>
            <div className={styles.breakdownItem}>
              <span>Stamp Duty</span>
              <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.stamp_duty).toLocaleString("US")}`}</span>
            </div>
            <div className={styles.breakdownItem}>
              <span>Total Before Taxes</span>
              <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.total_premium_before_taxes).toLocaleString("US")}`}</span>
            </div>
            <div className={`${styles.breakdownItem} ${styles.breakdownTotal}`}>
              <span>Final Amount</span>
              <span>{`${localStorage.getItem("coverageCountry") === "Kenya" ? "KES" : "RWF"} ${parseInt(totalValue.estimated_after_taxes).toLocaleString("US")}`}</span>
            </div>
          </div>
        </div>
      )}

      {premiumLoading && (
        <div className={styles.loadingState}>
          <Loader size={20} className={styles.spinner} />
          <span>Calculating premium...</span>
        </div>
      )}
    </div>
  );
};
